import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import VisitorFormIframe from "@/components/VisitorFormIframe";
import SubdomainLayout from "@/subdomains/SubdomainLayout";

import { useSubdomainPaths } from "@/subdomains/useContactPath";

export default function SubdomainContactPage({ config }) {
  const { theme } = config;
  const paths = useSubdomainPaths(config.slug);

  return (
    <SubdomainLayout config={config} testId={`subdomain-contact-page-${config.slug}`}>
      <section className={`${theme.cream} py-20 lg:py-28`} data-testid="subdomain-contact-hero">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="max-w-3xl">
            <div className={`text-xs font-bold tracking-[0.2em] uppercase mb-4 ${theme.primaryText}`}>
              Contact
            </div>
            <h1 className="text-4xl sm:text-5xl font-black tracking-tight text-zinc-900 leading-tight">
              Let&apos;s design your {config.shortName} solution
            </h1>
            <p className="mt-4 text-lg text-zinc-600 leading-relaxed">
              Share your requirements and our team will respond with a tailored demo and consultation.
            </p>
          </div>
        </div>
      </section>

      <section className="pb-20 lg:pb-28 bg-white" data-testid="subdomain-contact-form-section">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
            <div className="lg:col-span-4">
              <div className="border border-zinc-200 bg-white rounded-3xl p-8 shadow-sm">
                <h2 className="text-xl font-bold text-zinc-900">Get in touch</h2>
                <p className="mt-4 text-zinc-600 leading-relaxed">
                  Complete the visitor registration form and we&apos;ll connect you with the right{" "}
                  {config.shortName} expert.
                </p>
                <Link
                  to={paths.home}
                  className={`mt-8 inline-flex items-center gap-2 text-sm font-semibold ${theme.primaryText} hover:underline`}
                >
                  Back to {config.name}
                  <ArrowRight size={14} weight="bold" />
                </Link>
              </div>
            </div>

            <div className="lg:col-span-8">
              <div className="border border-zinc-200 bg-white rounded-3xl overflow-hidden shadow-lg">
                <VisitorFormIframe testId="subdomain-contact-visitor-form-iframe" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </SubdomainLayout>
  );
}
